<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Rinkmenos</h3>

    <v-row dense v-if="showRasytinisSuktikimas" class="mb-3">
      <v-col cols="12" md="12">
        <el-checkbox
          label="Rašytinis turto savininko (-ų) sutikimas kartu su sutartimi nepateikiamas, nes sutikimas subnuomai išreikštas nuomos sutartyje"
          :readonly="isReadonlyForm"
          v-model="sutikimas"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top v-if="showAddRinkmenos">
        <v-toolbar flat>
          <v-spacer></v-spacer>
          <el-button-prideti small primary @click.native.stop="newItem()">
            Prisegti rinkmeną
          </el-button-prideti>
        </v-toolbar>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-ntr-upload
      v-model="showUpload"
      :upload="modalUpload"
      :key="modalUploadKey"
      :multiple="false"
      :bylos-rusys="bylos_rusys"
      :max-dydis="rinkmenaDydis"
      @savedData="savedUpload"
    />

    <modal-delete
      title="Šalinti rinkmeną?"
      :text="
        `Ar norite pašalinti rinkmeną <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />

    <v-footer class="form-footer" v-if="!isReadonly">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="checkErrorsClick()"
        :loading="loadingTikrinti"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import checkErrors from '@/mixins/checkErrors'
import ModalNtrUpload from '../modals/ModalNtrUpload'
import ModalDelete from '../modals/ModalDelete'

export default {
  name: 'RegPrasymasRinkmenos',
  components: {
    ModalNtrUpload,
    ModalDelete,
  },
  mixins: [userRole, busena, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showUpload: false,
      modalUploadRefresh: 0,
      modalUpload: {},
      rinkmenaDydis: null,
      salys: [],
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      bylos: [],
      bylos_rusys: [],
      bylos_segamos: false,
      obj_dokumento_numeris: null,
      obj_dokumento_data: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      sutikimas: false,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasTipas', 'prasymasReadonly']),
    isReadonly() {
      return this.readonly
    },
    isReadonlyForm() {
      return this.readonlyForm
    },
    headers() {
      return [
        {
          text: 'Rūšis',
          align: 'start',
          value: 'byl_rusis',
        },
        {
          text: 'Dokumento nr.',
          align: 'start',
          value: 'byl_dokumento_nr',
        },
        {
          text: 'Dokumento data',
          align: 'start',
          value: 'byl_dokumento_data',
        },
        {
          text: 'Dokumento pavadinimas',
          align: 'start',
          value: 'byl_pavadinimas',
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 50,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.bylos.map(item => {
        if (!item.byl_id) {
          item.byl_rusis = 'Rengiamas dokumentas'
          item.byl_pavadinimas = 'Rengiamas dokumentas.pdf'
          item.byl_tipas = 'preview_ntr'
          item.byl_url = `ntrpaslaugos/prasymas/${this.prasymasID}/perziura`
          item.canDownload = true
          item.canEdit = false
          item.canDelete = false
          return item
        }
        item.byl_tipas = 'download'
        item.byl_url = `ntrpaslaugos/byla/${item.byl_id}/${item.byl_hash}/content`
        item.canDownload = item.byl_pavadinimas != null
        item.canEdit = this.bylos_segamos && !this.isReadonlyForm
        item.canDelete = this.isRengiamas || this.isGrazintas
        return item
      })
    },
    pridetiColor() {
      return !this.turtas
    },
    modalUploadKey() {
      return 'upload' + this.modalUploadRefresh
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    showAddRinkmenos() {
      return !this.isReadonlyForm && this.bylos_segamos
    },
    showRasytinisSuktikimas() {
      return this.isPrasymasSubnuoma && this.isPrasymasIregistravimas
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.loadingTikrinti = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/byla`)
        .then(res => {
          this.bylos = res.data.bylos
          this.bylos_rusys = res.data.bylos_rusys
          this.bylos_segamos = res.data.bylos_segamos
          this.obj_dokumento_numeris = res.data.obj_dokumento_numeris
          this.obj_dokumento_data = res.data.obj_dokumento_data
          this.rinkmenaDydis = parseInt(res.data.rinkmena_dydis)
          this.sutikimas = res.data.pra_sutikimas
          this.$emit('updated')
          this.updateErrors()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.loadingTikrinti = false
          this.pageloading = false
        })
    },
    editItem(item) {
      this.openUpload(item)
    },
    newItem() {
      this.openUpload({
        // byl_dokumento_nr: this.obj_dokumento_numeris,
        // byl_dokumento_data: this.obj_dokumento_data,
      })
    },
    openUpload(item) {
      this.modalUpload = {
        ...item,
      }
      this.modalUploadRefresh++
      this.showUpload = true
    },
    savedUpload() {
      this.getData()
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.byl_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`ntrpaslaugos/prasymas/${this.prasymasID}/byla/${item.byl_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkErrorsClick() {
      this.checkNtrErrors()
    },
  },
}
</script>
